import { Row, Spin } from 'antd';
import React, { Component } from 'react';
import { connect } from "react-redux";
import "../../asset/style/scanner/scanner.css";

import { globalUrlPrefix, progressStage, cassetteType } from "../../utils/const";
import { setDeviceIdle } from '../../action/device_status.action';
import { initPreviewForScan } from "../../action/preview_status.action";
import SingleCassetteComponent from '../../component/scanner/scanWorkflow/c240_single_cassette_view';


class ScanWorkflowC240 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentProcessStage: progressStage.LOAD_SLIDES,
            cassetteSize: 0,
            activeSlot: -1,
            busy:false, 
            showSummary: false,
            scannerProperties: {},
        }
    }
    
    componentDidMount = () => {
        this.getScannerProperties();
    }

    componentDidUpdate = () => {
    }

    getScannerProperties = () => {
        this.props.dispatch(setDeviceIdle(this.props.device_id));
        let res = {
            "data": {
                "rackSize": 4,
                "numberOfRacks": 2,
                "cassetteSize": 6,
                "isObjectiveSwitcherPresent": false,
                "allowScanOutputFormatChange": false,
                "allowObjectiveChange": false,
                "defaultConfig": {
                    "selectedPoints": null,
                    "slot": null,
                    "tray": null,
                    "rack": null,
                    "specimenType": "HNE_TISSUE",
                    "objectiveType": "FORTY_X",
                    "scanSpeed": "FAST",
                    "scanOutputFormat": "JPG",
                    "slideName": "",
                    "doTilingOnly": false,
                    "doTilingAfterScan": false,
                    "zstackLevels": 10,
                    "zstackStepSize": 0.1
                }
            },
            "status": 200,
            "statusText": "OK",
            "headers": {
                "connection": "keep-alive",
                "content-length": "462",
                "content-type": "application/json",
                "date": "Sun, 23 Jan 2022 19:34:19 GMT",
                "server": "WSGIServer/0.2 CPython/3.6.9",
                "vary": "Cookie, Origin, Accept-Encoding",
                "x-frame-options": "SAMEORIGIN",
                "x-powered-by": "Express"
            },
            "config": {
                "url": "/devices/1/settings/get_scanner_properties",
                "method": "get",
                "headers": {
                    "Accept": "application/json, text/plain, */*"
                },
                "transformRequest": [
                    null
                ],
                "transformResponse": [
                    null
                ],
                "timeout": 0,
                "xsrfCookieName": "XSRF-TOKEN",
                "xsrfHeaderName": "X-XSRF-TOKEN",
                "maxContentLength": -1
            },
            "request": {}
        }
        for (let i = 0; i < res.data.cassetteSize; i++) {
            this.initSlot(i, res.data.defaultConfig);
        }
        this.setState(Object.assign({}, this.state, {
            cassetteSize: res.data.cassetteSize,
            defaultConfig: res.data.defaultConfig,
            scannerProperties: res.data,
        }));
    }

    initSlot = (slot, defaultConfig) => {
        this.props.dispatch(initPreviewForScan(slot, defaultConfig));
    }

    handleProgressChange = (stage) => {
        this.setState({
            currentProcessStage: progressStage.stage,
        })
        this.props.history.push("/" + globalUrlPrefix + "/scannerflow/" + this.props.device_id + "/scan/" + stage);
    }
    
    render() {
        return (
            <div>
                {this.state.cassetteSize !== 0 ?
                    <Row className="rounded-container">
                        <SingleCassetteComponent 
                            handleProgressChange={this.handleProgressChange} 
                            device_id={this.props.device_id}
                            currentProcessIndex={1} 
                            previews={this.props.previews}
                            scannerProperties={this.state.scannerProperties}
                            defaultConfig={this.state.defaultConfig}
                            selectedCassette={this.props.selectedCassette}
                            barcodeTaken={this.props.barcodeTaken}
                            cassetteState={this.props.cassetteState}
                            cassetteType={this.props.cassetteType}
                            queue_state={this.props.queue_state}
                            onStartChangeScanRegionCallback = {this.props.onStartChangeScanRegionCallback}
                            onFinalizeScanRegionCallback = {this.props.onFinalizeScanRegionCallback}
                            barcodeCacheBustingKey = {this.props.barcodeCacheBustingKey}
                            cassetteQPreviewBtnDisable = {this.props.cassetteQPreviewBtnDisable}
                            onPreviewOnlyClick = {this.props.onPreviewOnlyClick}
                            enablePreviewBtn = {this.props.enablePreviewBtn}
                            cassetteQScanBtnDisable = {this.props.cassetteQScanBtnDisable}
                            onQScanClick = {this.props.onQScanClick}
                            enableQScanBtn = {this.props.enableQScanBtn}
                            onFinalizeSlideSettingsClick = {this.props.onFinalizeSlideSettingsClick}
                            onFinalizedSlideSettings = {this.props.onFinalizedSlideSettings}
                            isCassetteEmpty = {this.props.isCassetteEmpty}/>
                    </Row> :
                    <div style={{width: '100%', height: '800px'}} className="rounded-container">
                        <Spin spinning={this.state.cassetteSize === 0} tip="Loading...">
                            <div style={{width: '100%', height: '800px'}}></div>
                        </Spin>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        deviceProperties : state.deviceReducer,
        deviceStatus: state.deviceStatusReducer,
    };
};

export default connect(mapStateToProps)(ScanWorkflowC240);
